/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_CRR_DENOUNCED_CHECKS_ITEM = {
  id: 'denounced_checks',
  screenId: 'fin-crr-denounced-checks',
  label: 'Cheques denunciados',
  description: 'Consulta si un cheque figura denunciado en el BCRA.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Verificás si un cheque físico figura como denunciado (extraviado, sustraído o adulterado) en el registro del BCRA, antes de recibirlo o entregarlo.',
      },
      {
        title: 'Paso 1 — Elegir banco y número',
        fields: [
          {
            label: 'Banco',
            description: 'Lista de entidades del BCRA (se carga al abrir la pantalla). Obligatorio.',
          },
          {
            label: 'Número de cheque',
            description: 'Solo dígitos. Obligatorio.',
          },
        ],
        paragraphs: [
          'Tocá «Consultar» cuando ambos datos estén completos.',
        ],
      },
      {
        title: 'Paso 2 — Leer el resultado',
        bullets: [
          'Cheque no denunciado — mensaje en verde; el cheque no figura en el registro de denuncias.',
          'Cheque DENUNCIADO — aviso destacado con banco y número consultado.',
          'Fecha de procesamiento de la consulta.',
          'Si está denunciado, tabla con sucursal, N° de cuenta y causal de cada denuncia.',
        ],
      },
      {
        title: 'Diferencia con Situación crediticia',
        paragraphs: [
          'Acá consultás un cheque puntual por banco y número. En «Situación crediticia» consultás por CUIT y ves deudas y cheques rechazados de esa persona o empresa.',
        ],
      },
      {
        title: 'Si hay error',
        paragraphs: [
          'Si el banco no existe en el catálogo o el servicio del BCRA no responde, verás un mensaje de error. Reintentá más tarde o recargá la página si el servidor no respondió.',
        ],
      },
    ],
  },
}
